<app-modal-header title="What is a transformation alias?" (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>
  <div class="text-sm">
    <p>
      The <strong>Alias</strong> defines how you'll reference this transformation’s result inside custom code or later steps.
    </p>

    <ul class="list-disc list-inside space-y-1 my-3">
      <li><strong>Mostly optional</strong>: only needed if you're writing <em>custom code</em>.</li>
      <li><strong>Must be unique</strong>: each transformation should use a different alias.</li>
      <li><strong>Auto-generated</strong>: if you leave it blank, Onion will create one based on the transformation name.</li>
    </ul>

  </div>

</mat-dialog-content>
